import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const styles = {
    container: {
        minHeight: '100vh',
        backgroundColor: '#0f172a',
        color: '#fff',
        padding: '6rem 1rem 2rem',
    },
    content: {
        maxWidth: '760px',
        margin: '0 auto',
    },
    card: {
        background: 'rgba(255, 255, 255, 0.04)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        borderRadius: '24px',
        padding: '2rem',
        boxShadow: '0 24px 60px rgba(0, 0, 0, 0.28)',
    },
    eyebrow: {
        display: 'inline-block',
        marginBottom: '1rem',
        padding: '0.35rem 0.8rem',
        borderRadius: '999px',
        background: 'rgba(251, 191, 36, 0.12)',
        color: '#fbbf24',
        fontSize: '0.8rem',
        fontWeight: 700,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
    },
    title: {
        margin: '0 0 0.75rem',
        fontSize: '2rem',
        lineHeight: 1.2,
    },
    body: {
        margin: 0,
        color: '#cbd5e1',
        lineHeight: 1.7,
    },
    buttonRow: {
        display: 'flex',
        gap: '0.75rem',
        marginTop: '1.75rem',
        flexWrap: 'wrap',
    },
    primaryButton: {
        border: 'none',
        borderRadius: '12px',
        padding: '0.95rem 1.25rem',
        background: 'linear-gradient(135deg, #f59e0b, #ea580c)',
        color: '#fff',
        fontWeight: 700,
        cursor: 'pointer',
    },
    secondaryButton: {
        border: '1px solid rgba(255, 255, 255, 0.15)',
        borderRadius: '12px',
        padding: '0.95rem 1.25rem',
        background: 'transparent',
        color: '#e2e8f0',
        fontWeight: 600,
        cursor: 'pointer',
    },
};

export default function PremiumPageGate({ access, children }) {
    const navigate = useNavigate();
    const location = useLocation();

    if (access.loading) {
        return <div style={styles.container}><div style={styles.content}>Loading...</div></div>;
    }

    if (access.canAccess) {
        return children;
    }

    const isLoginState = access.needsLogin;
    const title = isLoginState
        ? `${access.product?.title || 'Premium content'} requires login`
        : `${access.product?.title || 'Premium content'} is not ready yet`;
    const body = isLoginState
        ? 'Sign in first to load your saved results and premium access state.'
        : access.missingMessage;

    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <div style={styles.card}>
                    <div style={styles.eyebrow}>Premium</div>
                    <h1 style={styles.title}>{title}</h1>
                    <p style={styles.body}>{body}</p>
                    <div style={styles.buttonRow}>
                        {isLoginState ? (
                            <button
                                type="button"
                                style={styles.primaryButton}
                                onClick={() => navigate('/login', { state: { from: location } })}
                            >
                                Go to Login
                            </button>
                        ) : (
                            <button
                                type="button"
                                style={styles.primaryButton}
                                onClick={() => navigate(access.ctaRoute)}
                            >
                                {access.ctaLabel}
                            </button>
                        )}
                        {!isLoginState && access.secondaryCtaRoute ? (
                            <button
                                type="button"
                                style={styles.secondaryButton}
                                onClick={() => navigate(access.secondaryCtaRoute)}
                            >
                                {access.secondaryCtaLabel}
                            </button>
                        ) : null}
                        <button
                            type="button"
                            style={styles.secondaryButton}
                            onClick={() => navigate('/mypage')}
                        >
                            Go to My Page
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
